import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import CONFIG from '../../config/apiConfig';

const generateGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const rand = (Math.random() * 16) | 0;
    const value = char === 'x' ? rand : (rand & 0x3) | 0x8;
    return value.toString(16);
  });
};

const useGuid = () => {
  const maxCredit = 3;
  const [guid, setGuid] = useState('');
  const [limitCredit, setLimitCredit] = useState(maxCredit);


  useEffect(() => {
    let savedGuid = Cookies.get('guid');

    if (!savedGuid) {
      savedGuid = generateGuid();
      Cookies.set('guid', savedGuid, { expires: 1, secure: true});

      { }
    }

    setGuid(savedGuid);
  }, []);

  useEffect(() => {
    if (guid) {
      fetchTotalScan();
    }
  }, [guid]);

  const fetchTotalScan = async () => {
    const payload = {
      device_info: guid
    };

    try {
      const response = await axios.post(
        CONFIG.API_URL + '/customer-total-scan',
        payload
      );

      let total = maxCredit - response?.data?.data?.scan_count;

      if(total < 0)
        total = 0;

      setLimitCredit(total)

    } catch (error) {
      console.error('Error fetching credit data:', error);
    }
  };


  return { maxCredit, guid, limitCredit };
};

export default useGuid;
